import { Box, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import dayjs from "dayjs";
import { SectionTitle, KvRow, EmptyState } from "../groupsUi";

/**
 * Formats an ISO date string for display, with a graceful fallback.
 * @param {string} value
 * @returns {string}
 */
function formatDate(value) {
    if (!value) return "—";
    const d = dayjs(value);
    return d.isValid() ? d.format("DD-MM-YYYY HH:mm") : "—";
}

/**
 * Maps a banking object to a human-readable status label.
 * Returns "Pas de compte" when banking is empty/undefined,
 * "Compte actif" for active, "Compte en attente" for draft/pending_connect,
 * "Compte échoué" for failed, and falls back to "Statut inconnu".
 * @param {Object} banking
 * @returns {string}
 */
function bankLabel(banking) {
    if (!banking || Object.keys(banking).length === 0) return "Pas de compte";
    if (banking.status === "active") return "Compte actif";
    if (banking.status === "draft" || banking.status === "pending_connect") return "Compte en attente";
    if (banking.status === "failed") return "Compte échoué";
    return "Statut inconnu";
}

/**
 * Builds the description block; long descriptions are wrapped.
 * @param {{description:string}} props
 */
function DescriptionBlock({ description }) {
    const textColor = useColorModeValue("secondaryGray.800", "whiteAlpha.900");
    return (
        <Box>
            <SectionTitle>Description</SectionTitle>
            <Text color={textColor} fontSize="0.85rem" whiteSpace="pre-wrap">
                {description || "Aucune description"}
            </Text>
        </Box>
    );
}

/**
 * Profile tab content (read-only display of group metadata).
 * @param {{detail:Object}} props
 */
function ProfileTab({ detail }) {
    if (!detail) return <EmptyState>Aucune donnée</EmptyState>;
    const services = (detail.services || []).length;
    return (
        <Stack spacing="16px">
            <DescriptionBlock description={detail.description} />
            <Box>
                <SectionTitle>Informations</SectionTitle>
                <KvRow label="ID" value={detail.id} />
                <KvRow label="Nom" value={detail.name} />
                <KvRow label="Photo" value={detail.photo ? "Définie" : "Aucune"} />
                <KvRow label="Cover" value={detail.cover_photo ? "Définie" : "Aucune"} />
                <KvRow label="Services" value={services} />
                <KvRow label="Compte bancaire" value={bankLabel(detail.banking)} />
                <KvRow label="Créé le" value={formatDate(detail.created_at)} />
                <KvRow label="Modifié le" value={formatDate(detail.modified_at)} />
            </Box>
        </Stack>
    );
}

export default ProfileTab;
